const ACTIVATION_CODE_FORMATTED = 'activationCodeFormatted';
const PARTNER_SIGNUP_STATUS = 'partnerSignupStatus';
const PARTNER_SIGNUP = 'partnerSignup';
const PARTNER_CODE_ERROR = 'partnerCodeErrorStatus';

export { ACTIVATION_CODE_FORMATTED, PARTNER_SIGNUP_STATUS, PARTNER_SIGNUP, PARTNER_CODE_ERROR };
